import React, { useCallback } from 'react';
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';

import { isVyjadreniPrijatoMessages } from './svuMessages';
import { StateBadge } from './StateBadge';
import { VYJADRENI_PRIJATO } from '../constants';

import { useAppContext, useHistoryAction } from '../../hooks';
import { R7aUrceniEditoraZpsListResponse } from '../../openapi/types';
import { getCmdCtrlUrl } from '../../utils/getcmdctrlurl';
import { RouteId } from '../../routes';

export const SvuListItem: React.FC<R7aUrceniEditoraZpsListResponse> = (props) => {
  const { appType } = useAppContext();
  const routeToSvuDetail = useHistoryAction('managerSvuDetail', { id: props.id });

  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if (event.ctrlKey || event.metaKey) {
        window.open(
          getCmdCtrlUrl('managerSvuDetail' as RouteId, { appType, id: props.id }),
          '_blank',
        );
        return; // Ponech nativní chování
      }
      const selectText = window.getSelection();
      if (!selectText || selectText.toString() === '') {
        routeToSvuDetail();
      }
    },
    [routeToSvuDetail],
  );

  return (
    <tr onClick={handleClick}>
      <td className='sg-a-ta-c'>
        <StateBadge state={props.state} />
        {props.id_uzemni_editace && <div className='sg-u-type-bold'>{props.id_uzemni_editace}</div>}
      </td>

      <td className='sg-u-type-bold'>{props.nazev}</td>
      <td>
        {props.vyjadreni_prijato != null ? (
          <FormattedMessage
            {...isVyjadreniPrijatoMessages[
            props.vyjadreni_prijato ? VYJADRENI_PRIJATO.TRUE : VYJADRENI_PRIJATO.FALSE
            ]}
          />
        ) : (
          ''
        )}
      </td>
      <td>{props.editor?.jmeno}</td>
      <td className='sg-a-ta-r sg-a-ws-nw sg-a-fvn-tn'>
        {props.created && (
          <div className='dmx-u-c-cta-green'>
            <FormattedDate value={new Date(props.created)} />{' '}
            <FormattedTime value={new Date(props.created)} />
          </div>
        )}
        {props.edited && (
          <div>
            <FormattedDate value={new Date(props.edited)} />{' '}
            <FormattedTime value={new Date(props.edited)} />
          </div>
        )}
      </td>
    </tr>
  );
};
